import React, { FC } from 'react';
import { Box, Checkbox, Text } from '@bechtel/gds';
import { FieldArray, FieldProps } from 'formik';
import { findIndex, some, map } from 'lodash';
import { ListSelectionStyled, DrawerSubHeaderStyled, SubListSelectionStyled } from '@bechtel/client-common';
import { Trans } from '@lingui/macro';
import { searchByList } from '../form-state';
import { useLingui } from '@lingui/react';

export const SearchByList: FC<FieldProps> = ({ form }) => {
  const { i18n } = useLingui();

  return (
    <Box flexDirection={{ sm: 'column' }} data-testid="search-by-container">
      <DrawerSubHeaderStyled>
        <Trans>Search By</Trans>
      </DrawerSubHeaderStyled>
      <SubListSelectionStyled
        onClick={() => {
          if (form.values.searchByList?.length !== searchByList.length) {
            form.setFieldValue('searchByList', map(searchByList, 'value'));
          } else {
            form.setFieldValue('searchByList', []);
          }
        }}
      >
        <Box alignItems={{ sm: 'center' }}>
          <Box mr={{ sm: '500' }}>
            <Checkbox
              data-testid="search-by-all"
              checked={form.values.searchByList?.length === searchByList.length}
              indeterminate={
                form.values.searchByList?.length > 0 && form.values.searchByList?.length < searchByList.length
              }
              readOnly
            />
          </Box>
          <Text size="400" weight="600" color="bechtel.grey.1000">
            <Trans>Select All</Trans>
          </Text>
        </Box>
        {form.values.searchByList && form.values.searchByList.length > 0 && (
          <Text size="400" color="bechtel.grey.1000" data-testid="search-by-selected-length">
            {form.values.searchByList.length} <Trans>Selected</Trans>
          </Text>
        )}
      </SubListSelectionStyled>
      <FieldArray name="searchByList">
        {(arrayHelpers) => {
          return (
            <>
              {searchByList.length > 0 &&
                searchByList.map((searchByItem) => {
                  return (
                    <ListSelectionStyled
                      key={searchByItem.value}
                      data-testid={`search-by-item-${searchByItem.value}`}
                      onClick={() => {
                        const selected = findIndex(form.values.searchByList, (item) => {
                          return item === searchByItem.value;
                        });
                        if (selected !== -1) {
                          arrayHelpers.remove(selected);
                        } else {
                          arrayHelpers.push(searchByItem.value);
                        }
                      }}
                    >
                      <Box mr={{ sm: '500' }}>
                        <Checkbox
                          checked={some(form.values.searchByList, (item) => {
                            return item === searchByItem.value;
                          })}
                          readOnly
                        />
                      </Box>
                      <Text size="400" color="bechtel.grey.1000">
                        {i18n._(searchByItem.label)}
                      </Text>
                    </ListSelectionStyled>
                  );
                })}
            </>
          );
        }}
      </FieldArray>
    </Box>
  );
};
